import styled from "styled-components";

export const StyledPasswordValidatorWrapper = styled.div`
  padding-bottom: 15px;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

export const StyledPasswordValidatorItem = styled.div`
  padding: 1px 4px;
  color: ${({ isValid }) => (
  isValid !== null ?  "white" : "black")};
  font-size: 12px;
  line-height: 16px; 
  border-radius: 4px;
  border: 1px solid ${({ isValid }) => (
  isValid !== null ? (isValid ? "green" : "red") : "black")};
  background-color: ${({ isValid }) => (
  isValid !== null ? (isValid ? "green" : "red") : "white")};
  cursor: pointer;
`;